Jelly.Handlers.Document_Click = function(event)
{
	// Call handlers functions for document level clicks		
	// No handler functions currently exist.	
};
